// extracted by mini-css-extract-plugin
export default {"cardContainer":"CardContainer_cardContainer__eJqqG","title":"CardContainer_title__2AOkC","title1":"CardContainer_title1__+a6V7"};